import https from 'hub-http/clients/apiClient';
const BASE_URL = 'leadin/v1';
export const fetchSettings = () => https.get(`${BASE_URL}/settings`);